export enum BookmarkState {
	ACTIVE = 'ACTIVE',
	SUGGESTED = 'SUGGESTED',
}
